export default __webpack_public_path__ + "static/media/Cv_For_PGJB.a6148339.pdf";